import { endOfDay, format, subDays } from 'date-fns';
import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchChannelOptions = new ReduxAsyncAction<'FETCH_CHANNEL_OPTIONS', void, any>('FETCH_CHANNEL_OPTIONS');

FetchChannelOptions.registerRequest(async (): Promise<any> => {
  const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
  const startTimestamp = format(endOfDay(new Date()), DATE_FORMAT);
  const endTimestamp = format(
    subDays(new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate())), 90),
    DATE_FORMAT
  );

  try {
    const { data } = await dash_api.post('/v1/marketing/topchannel', {
      start_time: startTimestamp,
      end_time: endTimestamp,
    });
    return data;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch channel options.', 'error');
    throw error;
  }
});

export const FETCH_CHANNEL_OPTIONS = FetchChannelOptions.actionNamespaceConstants;
export const fetchChannelOptions = FetchChannelOptions.request;

export type FetchChannelOptionsResponseAction = Action<typeof FETCH_CHANNEL_OPTIONS.response> & {
  data: any;
};
